<template>
  <div>
    <list
      row-key="EmpId"
      ref="list"
      unit="人员"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="人员工号">
          <el-input size="mini" v-model="params.EmpNo" placeholder="请输入人员工号" clearable />
        </el-form-item>
        <el-form-item label="人员姓名">
          <el-input size="mini" v-model="params.EmpName" placeholder="请输入人员姓名" clearable />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input size="mini" v-model="params.Mobile" placeholder="请输入手机号码" clearable />
        </el-form-item>
        <el-form-item label="人员职务">
          <job-select ref="jobSelect" v-model="params.JobId" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="EmpNo" label="人员工号" min-width="120px" />
        <el-table-column prop="EmpName" label="人员姓名" min-width="120px" />
        <el-table-column prop="DpName" label="所属部门" min-width="120px" />
        <el-table-column prop="Mobile" label="手机号码" min-width="120px" />
        <el-table-column prop="JobName" label="职务" min-width="120px" />
        <el-table-column label="部门领导" align="center" width="80px">
          <template slot-scope="{row}">
            <span>{{row.Leader?'是':'否'}}</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

import jobSelect from "@/components/sys/setting/job/select";

export default {
  mixins: [listMixin],
  components: { list, jobSelect },
  data() {
    return {
      api: require("@/api/ent/emp").default,
      params: {
        EmpNo: "",
        EmpName: "",
        Mobile: "",
        JobId: null,
      },
    };
  },
  methods: {
    logout(data) {
      console.log("logout", data);
      this.api.forceLogout({ UserId: data.UserId }).then((res) => {
        this.reload();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>